export const AVAILABLE_TO_BILL_BILLING_TRANSACTION_REDIRECT_KEY =
  'available-to-bill-to-billing-transaction-redirect-key';

export const INVOICE_DRAFT_STATUS_POLICY =
  'urn:replicon:policy:invoice:invoice-draft-status';
